

import './RangeSlider.scss';

const RangeSlider = ({options}) => {
  const allOptions = [...options];
  const first = allOptions[0];
  const last = allOptions[allOptions.length - 1];

  const values = {
    min: first.value,
    max: last.value,
  }

  return (
    <div className="range-slider">
      <input type="range" id="rangeSlider" name="rangeSlider" list="rangeValues" step={1} min={values.min} max={values.max}/>

      <datalist id="rangeValues">
        {allOptions.map((option)=>(
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </datalist>
    </div>
  );
};

export default RangeSlider;